/*----- Core -----*/
import React           from 'react'
import styled, { css } from 'styled-components'
import PropTypes 			 from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color from '../../commons/Color'

/*----- Styles -----*/
const StyledParagraphWithShadow = styled.p`
	${ Montserrat(18, 500, Color.grey ) };
	max-width: 600px;
	margin: 16px 0 16px 0;
	background: white;
	padding: 32px;
	border-radius: 8px;
	${props => props.bold && css`
		font-weight: 600;
  `}
`

/*----- Component -----*/
const ParagraphWithShadow = ({ content, bold }) => (
	<StyledParagraphWithShadow className="custom-paragraph" bold={bold}>{ content }</StyledParagraphWithShadow>
)
export default ParagraphWithShadow

/*----- PropTypes -----*/
ParagraphWithShadow.propTypes = {
  content: PropTypes.string.isRequired,
  bold:		 PropTypes.bool,
}
